import React from 'react'
import { isEmpty } from 'lodash'

import { Card } from '@/components/cards/Card'
import { Pill } from '@/components/pills/Pill'
import { Sparkline } from './Sparkline'
import { ConversionPanel } from './ConversionPanel'
import {
  getExperimentPanelProps,
  getOpportunityLabel,
  isRunningExperiment,
} from './AgenticInsights.helpers'
import { getExperimentDates } from './AgenticInsights.runReset'

// The Experiments-tab card. Mirrors the insight card's chrome, but the right
// panel reads Baseline → Measured with the measured value in green (a realized
// result, vs the insight card's projection).
export const ExperimentSpineCard = ({ insight, onOpen }) => {
  const { experiment } = insight
  if (!experiment) {
    return null
  }

  const running = isRunningExperiment(insight)
  const daysElapsed = experiment.daysElapsed ?? 0
  const daysToTrack = experiment.daysToTrack ?? 30
  const timeLabel = running ? `day ${daysElapsed} of ${daysToTrack}` : `ran ${daysToTrack} days`
  const { startDate, endDate, endLabel } = getExperimentDates(insight)

  return (
    <Card clickable className="experiment-spine-card" onClick={() => onOpen(insight.id)}>
      <div className="experiment-spine-card__main">
        <div className="experiment-spine-card__top">
          <Pill success={running} informative={!running} small>
            {running ? `Running · ${timeLabel}` : 'Completed'}
          </Pill>
          {insight.conversionOpportunity && (
            <span className="experiment-spine-card__opp">{getOpportunityLabel(insight)}</span>
          )}
        </div>
        <div className="experiment-spine-card__rec">{insight.recommendation || insight.title}</div>
        {/* The agent count that used to sit here counted agents with calls
            *since* launch — which reads as "0 agents" on day one, as though
            nothing was set up. */}
        <div className="experiment-spine-card__meta">
          {startDate && <span>Started {startDate}</span>}
          {endDate && (
            <span>
              {endLabel} {endDate}
            </span>
          )}
          {experiment.startedByUser && <span>Launched by {experiment.startedByUser}</span>}
        </div>
      </div>
      <div className="experiment-spine-card__stat">
        <ConversionPanel {...getExperimentPanelProps(insight)} />
        {!isEmpty(experiment.dailyTrend) && (
          <Sparkline
            data={experiment.dailyTrend}
            width={200}
            height={34}
            className="sparkline--measured"
            fill
          />
        )}
      </div>
    </Card>
  )
}
